import React, { useState, useEffect } from "react";
import { NAV_ITEMS } from "@/data";
import { useEnquiryForm } from "@/context/FormContext";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export const Logo = ({ subtitle = true }) => (
  <a href="/" className="flex flex-col leading-none" data-testid="brand-logo">
    <span className="font-head text-2xl font-semibold tracking-tight">
      Fund<span className="text-[#0057FF]">AI</span>
    </span>
    {subtitle && (
      <span className="font-mono text-[8px] tracking-[0.3em] text-zinc-500 mt-0.5 hidden sm:block">
        CAPITAL FOR AI · EXECUTION FOR GROWTH
      </span>
    )}
  </a>
);

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobile, setMobile] = useState(false);
  const { openForm } = useEnquiryForm();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${scrolled ? "glass border-b border-white/5" : "bg-transparent"}`} data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-7">
          {NAV_ITEMS.map((n) => (
            <a key={n.label} href={n.href} className="text-sm text-zinc-400 hover:text-white transition-colors whitespace-nowrap" data-testid={`nav-${n.label.toLowerCase().replace(/\W/g, "")}`}>{n.label}</a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <button onClick={() => openForm("general")} className="text-sm text-zinc-300 hover:text-white transition-colors px-3 py-2 whitespace-nowrap" data-testid="header-enquiry-btn">Enquire</button>
          <button onClick={() => openForm("founder")} className="text-sm bg-[#0057FF] hover:bg-[#0047D6] text-white rounded-full px-5 py-2.5 transition-colors active:scale-[0.98] whitespace-nowrap" data-testid="header-apply-btn">Apply for Funding</button>
        </div>
        <button className="lg:hidden text-white" onClick={() => setMobile(true)} aria-label="Open menu" data-testid="mobile-menu-btn"><Menu /></button>
      </div>

      <AnimatePresence>
        {mobile && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-50 bg-[#050507] lg:hidden overflow-y-auto">
            <div className="flex items-center justify-between px-6 h-20">
              <Logo subtitle={false} />
              <button onClick={() => setMobile(false)} aria-label="Close menu" data-testid="mobile-close-btn"><X className="text-white" /></button>
            </div>
            <div className="flex flex-col px-6 gap-1 mt-6">
              {NAV_ITEMS.map((n, i) => (
                <motion.a key={n.label} href={n.href} onClick={() => setMobile(false)} initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.05 }} className="text-2xl font-head py-3 border-b border-white/5">{n.label}</motion.a>
              ))}
              <button onClick={() => { setMobile(false); openForm("founder"); }} className="mt-8 bg-[#0057FF] text-white rounded-full py-4 text-lg font-medium">Apply for Funding</button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
